import { useTranslation } from 'react-i18next';

export default function PartnerCreditInsufficiencyNotice({
  visible,
  showTicketButton,
  onOpenTicket,
  ticketCreating = false,
}) {
  const { t } = useTranslation();
  if (!visible) return null;

  const body = showTicketButton
    ? 'moteurReservation.automaticPaymentMethods.insufficient_credit_body_partner'
    : 'moteurReservation.automaticPaymentMethods.insufficient_credit_body_admin';

  return (
    <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-4">
      <div className="flex flex-col gap-3">
        <div className="flex items-start gap-3">
          <svg className="h-5 w-5 text-red-500 shrink-0 mt-0.5" viewBox="0 0 20 20" fill="currentColor">
            <path
              fillRule="evenodd"
              d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
              clipRule="evenodd"
            />
          </svg>
          <div>
            <h3 className="text-sm font-semibold text-red-900">
              {t('moteurReservation.automaticPaymentMethods.insufficient_credit_title')}
            </h3>
            <p className="mt-1 text-sm text-red-800">{t(body)}</p>
          </div>
        </div>
        {showTicketButton && (
          <button
            type="button"
            onClick={onOpenTicket}
            disabled={ticketCreating}
            className="self-start px-4 py-2 rounded-xl text-sm font-medium text-white bg-[var(--color-primary-600)] hover:bg-[#4a3da3] transition-colors shadow-sm disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {ticketCreating
              ? t('moteurReservation.automaticPaymentMethods.ticket_creating', {
                  defaultValue: 'Création du ticket…',
                })
              : t('moteurReservation.automaticPaymentMethods.open_supplier_reclamation_ticket')}
          </button>
        )}
      </div>
    </div>
  );
}
